/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import Switch from 'react-switch'
import {
  Col,
  Row,
  FormGroup,
  Input,
  Button,
  ButtonGroup,
  Alert,
} from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  packagingInitialState,
  packageTypeOptions,
  productTypeOptions,
} from './constants'
import RFIInfantFruitsAndVegsProduct from 'models/RFIInfantFruitsAndVegsProduct'

const RFIInfantFruitsAndVegsPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const methods = useFormContext()

  const { setSelect, setSwitch, onChange, asterisk } = useFormUtils()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const {
        category,
        subCategory,
        ProductType,
        PackageType,
        Size,
        MultiPackageType,
        MultiPackageCount,
        Organic,
        NoAdditionalIngredients,
      } = current

      setPackaging({
        category,
        subCategory,
        ProductType,
        PackageType: {
          value: PackageType || '',
          label: PackageType.length > 0 ? PackageType : 'Package Type',
        },
        Size,
        MultiPackageType,
        MultiPackageCount,
        Organic,
        NoAdditionalIngredients,
      })
    } else if (!updating) {
      setCurrent(RFIInfantFruitsAndVegsProduct)
    }
    // eslint-disable-next-line
    }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.MultiPackageType) {
        methods.setValue('MultiPackageCount', current.MultiPackageCount)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={4}>
        <p>
          <strong>Product Type {asterisk}</strong>
        </p>
        <ButtonGroup>
          <Button
            outline
            color="success"
            className="btn-round"
            onClick={() => {
              setCurrent({
                ...current,
                subCategory: current.Organic ? '101RFI' : '001RFI',
                ProductType: productTypeOptions[0],
              })
            }}
            active={current?.ProductType === productTypeOptions[0]}
            size="sm"
          >
            {productTypeOptions[0]}
          </Button>
        </ButtonGroup>{' '}
        <ButtonGroup>
          <Button
            outline
            color="success"
            className="btn-round"
            onClick={() => {
              setCurrent({
                ...current,
                subCategory: current.Organic ? '102RFI' : '002RFI',
                ProductType: productTypeOptions[1],
              })
            }}
            active={current?.ProductType === productTypeOptions[1]}
            size="sm"
          >
            {productTypeOptions[1]}
          </Button>
        </ButtonGroup>{' '}
        <ButtonGroup>
          <Button
            outline
            color="success"
            className="btn-round"
            onClick={() => {
              setCurrent({
                ...current,
                subCategory: current.Organic ? '103RFI' : '003RFI',
                ProductType: productTypeOptions[2],
              })
            }}
            active={current?.ProductType === productTypeOptions[2]}
            size="sm"
          >
            {productTypeOptions[2]}
          </Button>
        </ButtonGroup>{' '}
        <br />
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
        </FormGroup>
        <Input value={packaging.Size} disabled />
      </Col>
      <Col xs={4}>
        <p>
          <strong>Package Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packageTypeOptions}
          name="PackageType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Package Type'}
          onChange={([selected]) => {
            setSelect(selected, 'PackageType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PackageType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Multi-pack</strong>
          </p>
          <Controller
            as={Switch}
            name="MultiPackageType"
            id="MultiPackageType"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.MultiPackageType}
          />
          <br />
          <br />
          <br />
          {current?.MultiPackageType === true && (
            <FormGroup>
              <p>
                <strong>Multi-pack Count {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="MultiPackageCount"
                placeholder={'Multi-pack Count'}
                onKeyDown={e => {
                  if (
                    ![
                      'Backspace',
                      'Delete',
                      'Tab',
                      'ArrowLeft',
                      'ArrowRight',
                    ].includes(e.key) &&
                    isNaN(parseInt(e.key))
                  ) {
                    e.preventDefault()
                  }
                }}
                control={methods.control}
                rules={{
                  maxLength: { value: 2, message: '⚠ 2 characters max.' },
                  required: {
                    value: true,
                    message: '⚠ Multi Pack Count is required.',
                  },
                  validate: MultiPackageCount => MultiPackageCount > 0,
                }}
                onChange={([event]) => {
                  onChange(event)
                  return event
                }}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="MultiPackageCount"
                  message={'⚠ Multi Pack Count must be greater than 0.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
        </FormGroup>
      </Col>
      <Col xs={4}>
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          onChange={([checked, event, id]) => {
            switch (current.subCategory || current.fkSubCategory) {
              case '001RFI':
              case '101RFI':
                setSwitch(checked, event, id, '101RFI', '001RFI')
                break
              case '002RFI':
              case '102RFI':
                setSwitch(checked, event, id, '102RFI', '002RFI')
                break
              case '003RFI':
              case '103RFI':
                setSwitch(checked, event, id, '103RFI', '003RFI')
                break
              default:
                break
            }
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.Organic}
        />
        <br />
        <hr />
        <p>
          <strong>
            I certify that this product does not contain added sugar, salt,
            starch, spices, fiber, or DHA. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="NoAdditionalIngredients"
          id="NoAdditionalIngredients"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.NoAdditionalIngredients}
          rules={{
            validate: NoAdditionalIngredients =>
              NoAdditionalIngredients === true,
          }}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="NoAdditionalIngredients"
            message={
              '⚠ You must certify that this product does not contain added sugar, salt, starch, spice, fiber, or DHA.'
            }
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default RFIInfantFruitsAndVegsPackage
